// ======================================================================
// File Name       : ContentDrillAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import { CONTENT_DRILL_LIST_SEARCH,
         CONTENT_DRILL_LIST_DOWNLOAD,
         CONTENT_DRILL_DETAIL,
         CONTENT_DELETE_DRILL,
         CONTENT_DRILL_SKIN_LIST,
         CONTENT_DRILL_EDIT } from '../../constants/ActionTypes';
import { commonCallApi } from '../../utils/ApiUtils';

/**
 * Action content drill get list
 * @param {*} searchInfo
 */
export function searchDrillList(searchInfo) {
  return dispatch => commonCallApi({
    path: 'DrillList',
    data: searchInfo,
    drillServer: true,
  }).then((result) => {
    dispatch({
      type: CONTENT_DRILL_LIST_SEARCH,
      drillListSearchResult: result,
    });
  });
}

/**
 * Action download drill  list
 * @param {*} searchInfo
 */
export function downloadDrillList(searchInfo) {
  return (dispatch) => {
    return commonCallApi({
      path: 'private/DrillListDownload',
      data: searchInfo,
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_LIST_DOWNLOAD,
        drillListDownloadResult: result,
      });
    });
  };
}

/**
 * Action get drill detail
 * @param {*} drillId
 */
export function getDrillDetail(drillId) {
  return (dispatch) => {
    return commonCallApi({
      path: 'DrillDetail',
      data: { drill_secern_id: drillId },
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_DETAIL,
        drillDetailInfoResult: result.drillInfo || null,
      });
      dispatch(getSkinList(result.drillInfo));
      return result;
    });
  };
}

/**
 * Action get skin list
 * @param {*} drillDetailInfo
 */
export function getSkinList(drillDetailInfo) {
  if (!drillDetailInfo) {
    return null;
  }
  return (dispatch) => {
    commonCallApi({
      path: 'SkinList',
      data: { skin_set_secern_id: drillDetailInfo.skinSetSecernId },
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_SKIN_LIST,
        skinListResult: result,
      });
    });
  };
}

/**
 * Action delete drill
 * @param {*} drillId
 */
export function deleteDrill(drillId) {
  return (dispatch) => commonCallApi({
      path: 'DrillDelete',
      data: { drill_secern_id: drillId },
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DELETE_DRILL,
        drillDetailInfoResult: result,
      });
    });
}

/**
 * Action content drill update
 * @param {*} drillInfo
 */
export function updateDrill(drillInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'DrillUpdate',
      data: drillInfo,
      drillServer: true,
      muiltipart: 1,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_EDIT,
        drillUpdateInfo: result,
      });
    });
  };
}
